'use strict';

import template from './select.html';

export default function f() {
  'ngInject';

  return {
    template: template,
    replace: true,
    transclude: true,
    require: 'ngModel',
    scope: {
      ngModel: '=',
      options: '='
    },
    link: {
      pre: function ($scope, $element, $attrs) {
        const select = $element.find('select');

        select.attr('id', $attrs.id);
        $element.removeAttr('id');

        $scope.optionsEpression = $attrs.optionsExpression;
      },
      post: function ($scope, $element, $attrs, ngModelCtrl) {
        const select = $element.find('select');

        select.on('blur', function () {
          $scope.$apply(function () {
            ngModelCtrl.$setTouched();
          });
        });

        ngModelCtrl.$render = function () {
          $scope.selectValue = ngModelCtrl.$modelValue;
        };

        $scope.$watch('selectValue', function (newValue) {
          ngModelCtrl.$setViewValue(newValue);
        });
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/select.js